/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Sync200ResponseOneOf1VirtualBrandsClosingTimesInner } from './Sync200ResponseOneOf1VirtualBrandsClosingTimesInner';
import {
    Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSON,
    Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSONTyped,
    Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSON,
    Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSONTyped,
} from './Sync200ResponseOneOf1VirtualBrandsClosingTimesInner';
import type { Sync200ResponseOneOf1Shifts } from './Sync200ResponseOneOf1Shifts';
import {
    Sync200ResponseOneOf1ShiftsFromJSON,
    Sync200ResponseOneOf1ShiftsFromJSONTyped,
    Sync200ResponseOneOf1ShiftsToJSON,
    Sync200ResponseOneOf1ShiftsToJSONTyped,
} from './Sync200ResponseOneOf1Shifts';

/**
 * 
 * @export
 * @interface Sync200ResponseOneOf1
 */
export interface Sync200ResponseOneOf1 {
    /**
     * 
     * @type {Array<any>}
     * @memberof Sync200ResponseOneOf1
     */
    tabs: Array<any>;
    /**
     * 
     * @type {any}
     * @memberof Sync200ResponseOneOf1
     */
    tabPromotions: any | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof Sync200ResponseOneOf1
     */
    reservations: Array<any>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Sync200ResponseOneOf1
     */
    startedShifts: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Sync200ResponseOneOf1
     */
    startedShiftsWithCashAmount: Array<string>;
    /**
     * 
     * @type {Sync200ResponseOneOf1Shifts}
     * @memberof Sync200ResponseOneOf1
     */
    shifts: Sync200ResponseOneOf1Shifts;
    /**
     * 
     * @type {number}
     * @memberof Sync200ResponseOneOf1
     */
    currentEventId: number;
    /**
     * 
     * @type {Array<Sync200ResponseOneOf1VirtualBrandsClosingTimesInner>}
     * @memberof Sync200ResponseOneOf1
     */
    virtualBrandsClosingTimes: Array<Sync200ResponseOneOf1VirtualBrandsClosingTimesInner>;
}

/**
 * Check if a given object implements the Sync200ResponseOneOf1 interface.
 */
export function instanceOfSync200ResponseOneOf1(value: object): value is Sync200ResponseOneOf1 {
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    if (!('tabPromotions' in value) || value['tabPromotions'] === undefined) return false;
    if (!('reservations' in value) || value['reservations'] === undefined) return false;
    if (!('startedShifts' in value) || value['startedShifts'] === undefined) return false;
    if (!('startedShiftsWithCashAmount' in value) || value['startedShiftsWithCashAmount'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('currentEventId' in value) || value['currentEventId'] === undefined) return false;
    if (!('virtualBrandsClosingTimes' in value) || value['virtualBrandsClosingTimes'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOf1FromJSON(json: any): Sync200ResponseOneOf1 {
    return Sync200ResponseOneOf1FromJSONTyped(json, false);
}

export function Sync200ResponseOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'tabs': json['tabs'],
        'tabPromotions': json['tabPromotions'],
        'reservations': json['reservations'],
        'startedShifts': json['startedShifts'],
        'startedShiftsWithCashAmount': json['startedShiftsWithCashAmount'],
        'shifts': Sync200ResponseOneOf1ShiftsFromJSON(json['shifts']),
        'currentEventId': json['currentEventId'],
        'virtualBrandsClosingTimes': ((json['virtualBrandsClosingTimes'] as Array<any>).map(Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSON)),
    };
}

export function Sync200ResponseOneOf1ToJSON(json: any): Sync200ResponseOneOf1 {
    return Sync200ResponseOneOf1ToJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ToJSONTyped(value?: Sync200ResponseOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabs': value['tabs'],
        'tabPromotions': value['tabPromotions'],
        'reservations': value['reservations'],
        'startedShifts': value['startedShifts'],
        'startedShiftsWithCashAmount': value['startedShiftsWithCashAmount'],
        'shifts': Sync200ResponseOneOf1ShiftsToJSON(value['shifts']),
        'currentEventId': value['currentEventId'],
        'virtualBrandsClosingTimes': ((value['virtualBrandsClosingTimes'] as Array<any>).map(Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSON)),
    };
}

